import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationConfirm',
  props: {
    value: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["input", "confirm", "skip"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', v: boolean): void
  (e: 'confirm', note: string): void
  (e: 'skip'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean
  loading?: boolean
};





const note = ref('')

watch(
  () => props.value,
  (val) => {
    if (!val) {
      note.value = ''
    }
  },
)

function onConfirm(toggleDialog: () => void) {
  if (props.loading) return
  emit('confirm', note.value)
  toggleDialog()
}

function onSkip(toggleDialog: () => void) {
  if (props.loading) return
  emit('skip')
  toggleDialog()
}

return { __sfc: true,props, emit, note, onConfirm, onSkip }
}

})